<template>
    <div>
        <Pane />
        <a-card class="container">
            <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }" :colon="false" :form="form">
                <a-row>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="会议名称">
                            <a-input v-decorator="[
                'name',
                {
                    rules: [
                        { required: true, message: '请输入！' },
                    ],
                },
            ]" style="width: 200px"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="会议时间">
                            <a-date-picker v-decorator="[
                'meetingTime',
                {
                    rules: [
                        { required: true, message: '请输入！' },
                    ],
                },
            ]" style="width: 200px" />
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="会议地点">
                            <a-input v-decorator="[
                'place',
                {
                    rules: [
                        { required: true, message: '请输入！' },
                    ],
                },
            ]" style="width: 200px"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="签发对象">
                            <a-input v-decorator="[
                'issueObject',
                {
                    rules: [
                        { required: true, message: '请输入！' },
                    ],
                },
            ]" style="width: 200px"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <a-form-item label="决议事项">
                            <a-input v-decorator="[
                'decisionItems',
                {
                    rules: [
                        { required: true, message: '请输入！' },
                    ],
                },
            ]" style="width: 200px"></a-input>
                        </a-form-item>
                    </a-col>
                </a-row>

                <div class="center">
                    <a-space>
                        <a-button @click="$close($route.path)">关闭</a-button>
                        <a-button type="primary" :loading="loading" @click="handleSubmit"
                            >保存</a-button
                        >
                        <a-button type="primary" :loading="loading" @click="process"
                            >保存并发布</a-button
                        >
                    </a-space>
                </div>
            </a-form>
        </a-card>
    </div>
</template>

<script>
import request from "@/api/request";
import organization from "@/mixins/organization";
function save(data) {
    return request({
        url: "/office-service/quality/meeting/add",
        method: "post",
        data
    });
}
export default {
    name: "safeDailyWorkAdd",
    mixins: [organization],

    data() {
        return {
            form: this.$form.createForm(this),
            companyList: [],
            projectList: [],
            loading: false,
        };
    },
    mounted() {
    },
    methods: {
        process(e) {
            e.preventDefault();
            this.hanldeSave(true);
        },
        handleSubmit(e) {
            e.preventDefault();
            this.hanldeSave(false);
        },
        hanldeSave(isRaise) {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.loading = true;
                    save({
                        name: values.name,
                        place: values.place,
                        issueObject: values.issueObject,
                        decisionItems: values.decisionItems,
                        meetingTime: values.meetingTime,
                        isRaise: isRaise,
                    })
                        .then(() => {
                            this.$close(this.$route.path);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            });
        }
    },
};
</script>


<style lang="less" scoped>
.container {
    padding: 12px;
}

.center {
    margin-top: 80px;
    margin-bottom: 80px;
}
</style>